// Clean Polling-based Swatch Fix with Size Buttons - Compatible with Theme
var cardStates = [];

function scanAndUpdateCards() {
  // Handle both regular product cards and new product cards
  var allCards = document.querySelectorAll('.product-card, .product-card--new-layout');
  
  allCards.forEach(function(card, index) {
    // Check for both dropdown types and hidden inputs
    var dropdown = card.querySelector('select[name="id"]') || card.querySelector('.new-card__variant-select');
    var hiddenInput = card.querySelector('input[type="hidden"][name="id"]');
    
    // If neither dropdown nor hidden input exists, skip
    if (!dropdown && !hiddenInput) return;
    
    var productLinks = card.querySelectorAll('a[href*="/products/"]:not(.product-card__title):not(.new-card__title-link)');
    var currentUrl = window.location.href;
    var activeLink = null;
    
    // Try to detect which swatch is currently active
    productLinks.forEach(function(link) {
      if (currentUrl.includes(link.href.split('/products/')[1]) ||
          link.style.opacity === '1' ||
          link.classList.contains('active') ||
          link.classList.contains('selected') ||
          getComputedStyle(link).opacity === '1') {
        activeLink = link;
      }
    });
    
    // If no active link found, check URL matching
    if (!activeLink && productLinks.length > 0) {
      var pageProductHandle = window.location.pathname.split('/products/')[1];
      if (pageProductHandle) {
        pageProductHandle = pageProductHandle.split('/')[0].split('?')[0];
        productLinks.forEach(function(link) {
          var linkHandle = link.href.split('/products/')[1];
          if (linkHandle) {
            linkHandle = linkHandle.split('/')[0].split('?')[0];
            if (linkHandle === pageProductHandle) {
              activeLink = link;
            }
          }
        });
      }
    }
    
    // If no swatch links found, get product handle from main product link
    if (!activeLink && productLinks.length === 0) {
      var mainProductLink = card.querySelector('a[href*="/products/"]');
      if (mainProductLink) {
        activeLink = mainProductLink;
      }
    }
    
    if (activeLink) {
      var productHandle = activeLink.href.split('/products/')[1];
      if (productHandle) {
        productHandle = productHandle.split('/')[0].split('?')[0];
        
        // Check if this card's state has changed
        var cardState = cardStates[index];
        if (!cardState || cardState.productHandle !== productHandle) {
          updateCardWithButtons(card, productHandle, index, dropdown, hiddenInput);
          cardStates[index] = {
            productHandle: productHandle,
            lastUpdate: Date.now()
          };
        }
      }
    }
  });
}

function updateCardWithButtons(card, productHandle, cardIndex, dropdown, hiddenInput) {
  fetch('/products/' + productHandle + '.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(product) {
      // Skip if product has only one variant and it's the default
      if (product.variants && product.variants.length === 1 && product.variants[0].title === 'Default Title') {
        return;
      }
      
      // Create or find the size buttons container
      var buttonsContainer = card.querySelector('.size-buttons-container');
      if (!buttonsContainer) {
        buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'size-buttons-container';
        
        // Handle different card layouts
        if (card.classList.contains('product-card--new-layout')) {
          // For new-arrivals cards: place buttons inside actions container, before the form
          var actionsContainer = card.querySelector('.new-card__actions-container');
          var productForm = card.querySelector('.new-card__product-form');
          
          if (actionsContainer && productForm) {
            actionsContainer.insertBefore(buttonsContainer, productForm);
          } else if (actionsContainer) {
            actionsContainer.appendChild(buttonsContainer);
          } else {
            // Fallback: place after title/price section
            var titlePriceWrapper = card.querySelector('.new-card__title-price-desktop-wrapper');
            if (titlePriceWrapper) {
              titlePriceWrapper.parentNode.insertBefore(buttonsContainer, titlePriceWrapper.nextSibling);
            }
          }
        } else {
          // For regular product cards: place before add to cart button
          var addToCartBtn = card.querySelector('button[type="submit"]');
          if (addToCartBtn) {
            addToCartBtn.parentNode.insertBefore(buttonsContainer, addToCartBtn);
          } else if (dropdown) {
            dropdown.parentNode.insertBefore(buttonsContainer, dropdown);
          } else if (hiddenInput) {
            hiddenInput.parentNode.insertBefore(buttonsContainer, hiddenInput);
          }
        }
      }
      
      // Handle dropdown if it exists
      if (dropdown) {
        // Keep the dropdown but make it visually hidden (not display:none to preserve functionality)
        dropdown.style.position = 'absolute';
        dropdown.style.left = '-9999px';
        dropdown.style.opacity = '0';
        dropdown.style.pointerEvents = 'none';
        
        // Clear dropdown and rebuild it with new product variants
        dropdown.innerHTML = '';
      }
      
      // Handle hidden input if it exists (for single variant products)
      if (hiddenInput && !dropdown) {
        // For products that only had hidden input, create a dropdown for our system
        dropdown = document.createElement('select');
        dropdown.name = 'id';
        dropdown.style.position = 'absolute';
        dropdown.style.left = '-9999px';
        dropdown.style.opacity = '0';
        dropdown.style.pointerEvents = 'none';
        
        // Insert the dropdown near the hidden input
        hiddenInput.parentNode.insertBefore(dropdown, hiddenInput);
      }
      
      // Clear existing buttons
      buttonsContainer.innerHTML = '';
      
      var hasStock = false;
      var firstAvailableId = null;
      
      if (product.variants && product.variants.length > 0) {
        // Rebuild dropdown options (required for theme functionality)
        product.variants.forEach(function(variant) {
          var option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title === 'Default Title' ? 'One Size' : variant.title;
          
          if (variant.available) {
            if (!firstAvailableId) {
              firstAvailableId = variant.id;
              option.selected = true;
            }
            hasStock = true;
          } else {
            option.disabled = true;
          }
          
          if (dropdown) {
            dropdown.appendChild(option);
          }
        });
        
        // Create visual buttons
        product.variants.forEach(function(variant) {
          var title = variant.title === 'Default Title' ? 'One Size' : variant.title;
          
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'size-button';
          button.textContent = title;
          button.setAttribute('data-variant-id', variant.id);
          
          if (variant.available) {
            button.className += ' available';
            if (variant.id === firstAvailableId) {
              button.classList.add('selected');
            }
          } else {
            button.className += ' sold-out';
            button.disabled = true;
          }
          
          // Add click handler that works with theme's system
          button.addEventListener('click', function() {
            if (!this.disabled) {
              // Remove selected class from all buttons
              buttonsContainer.querySelectorAll('.size-button').forEach(function(btn) {
                btn.classList.remove('selected');
              });
              
              // Add selected class to clicked button
              this.classList.add('selected');
              
              var variantId = this.getAttribute('data-variant-id');
              
              // Update the dropdown value (this is what the theme expects)
              if (dropdown) {
                dropdown.value = variantId;
                
                // Trigger the dropdown change event - this is crucial for theme compatibility
                var changeEvent = new Event('change', { 
                  bubbles: true, 
                  cancelable: true 
                });
                dropdown.dispatchEvent(changeEvent);
                
                // Also trigger input event for additional compatibility
                var inputEvent = new Event('input', { 
                  bubbles: true, 
                  cancelable: true 
                });
                dropdown.dispatchEvent(inputEvent);
              }
              
              // Update hidden input if it exists
              if (hiddenInput) {
                hiddenInput.value = variantId;
              }
            }
          });
          
          buttonsContainer.appendChild(button);
        });
        
        // Set the dropdown and hidden input to first available variant and trigger change
        if (firstAvailableId) {
          if (dropdown) {
            dropdown.value = firstAvailableId;
            
            // Trigger change event for the theme's JavaScript to process
            setTimeout(function() {
              var changeEvent = new Event('change', { 
                bubbles: true, 
                cancelable: true 
              });
              dropdown.dispatchEvent(changeEvent);
            }, 100);
          }
          
          if (hiddenInput) {
            hiddenInput.value = firstAvailableId;
          }
        }
      }
      
      // Update add to cart button
      var addToCartButton = card.querySelector('.new-card__add-to-cart-btn') || card.querySelector('button[type="submit"]');
      if (addToCartButton) {
        addToCartButton.disabled = !hasStock;
        var buttonText = addToCartButton.querySelector('span');
        if (buttonText) {
          buttonText.textContent = hasStock ? 'ADD TO CART' : 'SOLD OUT';
        } else {
          addToCartButton.textContent = hasStock ? 'ADD TO CART' : 'SOLD OUT';
        }
      }
    })
    .catch(function(error) {
      // Silent error handling
    });
}

function startPolling() {
  // Initial scan
  scanAndUpdateCards();
  
  // Poll every 500ms
  setInterval(scanAndUpdateCards, 500);
  
  // Also scan when URL changes
  var lastUrl = window.location.href;
  setInterval(function() {
    if (window.location.href !== lastUrl) {
      lastUrl = window.location.href;
      setTimeout(scanAndUpdateCards, 100);
    }
  }, 100);
}

// Add CSS to hide dropdowns immediately and style buttons
var buttonStyles = document.createElement('style');
buttonStyles.textContent = `
  /* Hide original dropdowns immediately to prevent flash */
  .product-card select[name="id"],
  .new-card__variant-select {
    position: absolute !important;
    left: -9999px !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }
  
  .size-buttons-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
  }
  
  /* For new-arrivals cards: make buttons and add to cart full width and stacked */
  .product-card--new-layout .new-card__actions-container {
    flex-direction: column !important;
    gap: 8px !important;
    align-items: stretch !important;
  }
  
  .product-card--new-layout .size-buttons-container {
    width: 100% !important;
    justify-content: space-between !important;
    order: 1 !important;
    margin-bottom: 8px !important;
  }
  
  .product-card--new-layout .new-card__variants-wrapper {
    order: 2 !important;
    width: 100% !important;
  }
  
  .product-card--new-layout .new-card__product-form {
    width: 100% !important;
    max-width: none !important;
    justify-content: stretch !important;
  }
  
  .product-card--new-layout .new-card__add-to-cart-btn {
    width: 100% !important;
    max-width: none !important;
    flex: none !important;
  }
  
  .size-button {
    padding: 8px 16px;
    border: 2px solid #ddd;
    background: white;
    color: #333;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    min-width: 40px;
    box-sizing: border-box;
  }
  
  .size-button:hover:not(:disabled) {
    border-color: #666;
  }
  
  .size-button.selected {
    background: #6366f1;
    color: white;
    border-color: #6366f1;
  }
  
  .size-button.sold-out {
    background: #f5f5f5;
    color: #999;
    border-color: #ddd;
    cursor: not-allowed;
    text-decoration: line-through;
  }
  
  .size-button.sold-out:hover {
    border-color: #ddd;
  }
  
  /* Mobile responsive styles - ensure all buttons fit */
  @media (max-width: 768px) {
    .size-buttons-container {
      flex-wrap: nowrap;
      justify-content: space-between;
      gap: 2px;
      overflow: hidden;
      width: 100%;
      padding: 0;
      margin-left: 0;
      margin-right: 0;
    }
    
    .size-button {
      flex: 1 1 0;
      min-width: 0;
      max-width: none;
      padding: 5px 1px;
      font-size: 10px;
      white-space: nowrap;
      text-align: center;
      border-width: 1px;
      margin: 0;
    }
    
    /* New arrivals mobile adjustments */
    .product-card--new-layout .size-button {
      font-size: 9px;
      padding: 4px 1px;
    }
  }
  
  /* Very small screens */
  @media (max-width: 480px) {
    .size-buttons-container {
      gap: 1px;
    }
    
    .size-button {
      padding: 4px 0px;
      font-size: 9px;
      border-radius: 2px;
    }
    
    .product-card--new-layout .size-button {
      font-size: 8px;
      padding: 3px 0px;
    }
  }
`;
document.head.appendChild(buttonStyles);

// Initialize immediately when script loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(startPolling, 100); // Reduced delay for faster initialization
  });
} else {
  setTimeout(startPolling, 100); // Reduced delay for faster initialization
}